import { EDIT_LISTING_SEO_KEYWORDS,
         CLOSE_LISTING_SEO_KEYWORDS,
         PENDING_SUBMIT_LISTING_SEO_KEYWORDS,
         COMPLETE_SUBMIT_LISTING_SEO_KEYWORDS,
         FAILED_SUBMIT_LISTING_SEO_KEYWORDS
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false,
    propertyseokeywordsediting: false
}


const mlListingSEOKeywords = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_LISTING_SEO_KEYWORDS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyseokeywordsediting: true
        }

        case CLOSE_LISTING_SEO_KEYWORDS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyseokeywordsediting: false
        }

        case PENDING_SUBMIT_LISTING_SEO_KEYWORDS: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_SEO_KEYWORDS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_SEO_KEYWORDS: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingSEOKeywords